<template>
  <div class="headCont flex-ac flex-c" :class="theme">
    <div class="layout flex-ac flex-c" style="height: 66px">
      <img src="@/assets/img/Group 722.png" class="logo pointer" alt="" @click="navClick()" />
      <img src="@/assets/img/Group 722@2x.png" class="logo pointer" :style="{ opacity: theme == 'dark' ? 1 : 0 }" alt=""
        @click="navClick()" />
      <div class="flex-ac flex-c navigation">
        <span v-for="it in navigation" class="pointer" style="margin:0 30px" :key="it.name"
          :style="{ color: setColor(it.name) }" @click="navClick(it.name)">{{ it.label
          }}</span>
      </div>
      <div v-if="false" class="themeSwitch pointer" :class="[theme]"
        @click="theme = theme == 'light' ? 'dark' : 'light'; switchChange();">
        <img src="@/assets/img/light.png" alt="" class="themeSwitch_icon themeSwitch_light" />
        <img src="@/assets/img/dark.png" alt="" class="themeSwitch_icon themeSwitch_dark" />
      </div>
      <i v-if="!userLoginInfo" class="loginBtn flex-ac flex-c pointer" @click="dialogVisible_login = true">注册/登录</i>
    </div>
  </div>
  <el-dialog :append-to-body="true" align-center v-model="dialogVisible_login" v-if="dialogVisible_login"
    :close-on-click-modal="false" :class="'loginDialog'" :close-on-press-escape="false">
    <div class="loginCont" style="height:516px;max-width:886px;">
      <p class="loginTitle">请先登录后使用</p>
      <div class="flex-ac flex-sb" style="height: 388px;">
        <div class="loginWx" style="border-right: 1px solid #eeeeee;">
          <div class="loginWxTitle">微信扫码注册/登录</div>
          <div style="width:300px;height:200px;margin:0 auto;overflow:hidden;">
            <div id="qrCodeUrl"></div>
          </div>
        </div>
        <div class="loginForm">
          <div class="loginFormTitle">
            <span class="pointer" :class="loginType == 'VCODE' ? 'loginTypeOn' : ''"
              @click="loginType = 'VCODE'">验证码登录</span>
            <i>|</i>
            <span class="pointer" :class="loginType == 'ACCOUNT' ? 'loginTypeOn' : ''"
              @click="loginType = 'ACCOUNT'">密码登录</span>
          </div>
          <div class="loginFormBox">
            <el-input clearable v-model="loginForm.mobile" placeholder="请输入手机号" v-show="loginType == 'VCODE'">
              <template #prepend>
                <el-select v-model="loginForm.countryCode" placeholder="Select" style="width: 80px">
                  <el-option label="+86" value="+86" />
                </el-select>
              </template>
            </el-input>
            <el-input clearable v-model="loginForm.code" v-show="loginType == 'VCODE'" placeholder="请输入验证码"
              style="margin-top: 20px">
              <template #append>
                <span @click="smsCode" class="smsCode" :class="checkTime == 0 ? 'pointer' : 'no-drop'">{{
                  checkTime == 0 ? "获取验证码" : checkTime + "秒后获取"
                }}</span>
              </template>
            </el-input>

            <el-input clearable v-model="loginForm.account" v-show="loginType == 'ACCOUNT'" placeholder="请输入账号"
              style="margin-top: 20px">
            </el-input>
            <el-input clearable v-model="loginForm.password" v-show="loginType == 'ACCOUNT'" placeholder="请输入密码"
              type="password" style="margin-top: 20px">
            </el-input>
            <div class="loginSubmit flex-ac flex-c" :disabled="loginLoading" :class="[
              loginForm.mobile && loginForm.code ? 'pointer' : 'no-drop',
            ]" @click="verifyUserSmsCode" v-if="loginType == 'VCODE' || loginType == 'AUTHORIZATION'">
              一键注册/登录
            </div>
            <div class="loginSubmit flex-ac flex-c" :disabled="loginLoading" :class="[
              loginForm.account && loginForm.password ? 'pointer' : 'no-drop',
            ]" @click="verifyUserBeforeLogin" v-if="loginType == 'ACCOUNT' || loginType == 'AUTHORIZATION'">
              登录
            </div>
            <div class="loginCheck flex-ac flex-c">
              <img class="loginCheckbox pointer" :src="require('@/assets/img/check' +
                (loginCheckbox ? 'On' : '') +
                '.png')
                " @click="loginCheckbox = !loginCheckbox" alt="" />已阅读并同意<span class="pointer"
                @click="dialogVisible_agreement = true">《用户协议及隐私政策》</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :append-to-body="true" align-center v-model="dialogVisible_agreement" v-if="dialogVisible_agreement"
      :close-on-click-modal="false" :class="'loginAgreement'" :close-on-press-escape="false">
      协议
    </el-dialog>
  </el-dialog>
  <el-dialog :append-to-body="true" align-center v-model="dialogVisible_bind" v-if="dialogVisible_bind"
    :close-on-click-modal="false" :class="'loginDialog'" :close-on-press-escape="false">
    <div class="loginCont" style="max-width:438px;" :style="{ height: bindType == 'VCODE' ? '350px' : '420px' }">
      <p class="loginTitle"> 请先绑定{{ bindType == 'VCODE' ? '手机号码' : '微信账号' }}后使用</p>
      <div class="flex-ac flex-sb" style="height: 280px;">
        <div class="loginWx" v-show="bindType == 'AUTHORIZATION'">
          <div class="loginWxTitle">微信扫码注册/登录</div>
          <div style="width:300px;height:200px;margin:0 auto;overflow:hidden;">
            <div id="qrCodeUrl"></div>
          </div>
        </div>
        <div class="loginForm" v-show="bindType == 'VCODE'">
          <div class="loginFormBox">
            <el-input clearable v-model="loginForm.mobile" placeholder="请输入手机号">
              <template #prepend>
                <el-select v-model="loginForm.countryCode" placeholder="Select" style="width: 80px">
                  <el-option label="+86" value="+86" />
                </el-select>
              </template>
            </el-input>
            <el-input clearable v-model="loginForm.code" v-show="bindType == 'VCODE'" placeholder="请输入验证码"
              style="margin-top: 20px">
              <template #append>
                <span @click="smsCode" class="smsCode" :class="checkTime == 0 ? 'pointer' : 'no-drop'">{{
                  checkTime == 0 ? "获取验证码" : checkTime + "秒后获取"
                }}</span>
              </template>
            </el-input>
            <div class="loginSubmit flex-ac flex-c" :disabled="loginLoading"
              :class="[loginForm.mobile && loginForm.code ? 'pointer' : 'no-drop',]" @click="bindFunc">
              绑定手机号
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script setup>
import "@/assets/js/wxLogin.js";
import auth from "@/api/auth.js";
import {
  ref,
  computed,
  onMounted,
  onBeforeMount,
  onBeforeUnmount,
  watch,
  getCurrentInstance,
} from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
import { ElMessage } from 'element-plus'
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
const store = useStore();
const { theme, userLoginInfo, chatUuid, isSend, openLogin } = storeToRefs(store);
const { setTheme, setUserLoginInfo, setChatUuid, setOpenLogin } = store;

// 获取全局属性 $config
const { $config } = getCurrentInstance().appContext.config.globalProperties;

const navigation = ref([
  { label: "我的档案", name: "myRecord" },
  { label: "择校方案", name: "schoolSelectPlan" },
  { label: "我的文书", name: "myDocuments" },
  { label: "我的申请", name: "myApplication" },
  // { label: "财务方案", name: "finance" },
  // { label: "我的订单", name: "myOrder" },
]);
const dialogVisible_agreement = ref(false);
const dialogVisible_login = ref(false);
const dialogVisible_bind = ref(false);
const checkWXTimer = ref(null);
const checkCodeTimer = ref(null);
const loginState = ref(null);
const loginType = ref("ACCOUNT"); //ACCOUNT 账号  AUTHORIZATION 微信扫码  VCODE 验证码
const loginForm = ref({
  mobile: "",
  code: "",
  account: "",
  password: "",
  countryCode: "+86",
  openId: "",
});
const checkTime = ref(0);
const loginCheckbox = ref(false);

const bindType = ref('VCODE');
const bindToken = ref('');
const bindRes = ref(null);
const loginLoading = ref(false);

watch(dialogVisible_login, (v) => {
  loginLoading.value = false;
  if (v) {
    dialogVisible_bind.value = false
    loginType.value = "ACCOUNT";
    getWechatLoginQrCode();
  } else {
  }
});
watch(dialogVisible_bind, (v) => {
  if (!v) {
    clearInterval(checkWXTimer.value);
  }
});
watch(openLogin, (v) => {
  loginLoading.value = false;
  dialogVisible_bind.value = false
  loginType.value = "ACCOUNT";
  if (v) {
    dialogVisible_login.value = true;
  }
})
const navClick = (name) => {
  if (!userLoginInfo.value) {
    dialogVisible_login.value = true
    ElMessage.info("请先登录");
    return
  }
  if (!name) {
    setChatUuid(null);
  }
  router.push({ name: name || "home" });
};

const switchChange = () => {
  setTheme(theme.value);
};
const setColor = (name) => {
  return router.currentRoute.value.name == name ? '#4284FF' : ''
}
// 初始化微信二维码
const getWechatLoginQrCode = () => {
  auth
    .getWechatLoginQrCode({
      platformCode: "YPLAN",
    })
    .then((res) => {
      new WxLogin({
        self_redirect: true,
        id: "qrCodeUrl",
        appid: res.data.appId,
        scope: res.data.scpoe,
        redirect_uri: res.data.redirectUrl,
        state: res.data.state,
        style: "",
        href: "",
        stylelite: 1,
        onReady: () => {
          clearInterval(checkWXTimer.value);
          checkWXTimer.value = setInterval(() => {
            getWxPcLoginInfo();
          }, 1000);
        },
      });
      loginState.value = res.data.state;
    });
};
// 微信登录后
const getWxPcLoginInfo = () => {
  auth
    .getWxPcLoginInfo({
      state: loginState.value,
    })
    .then((res) => {
      if (res.data) {
        if (res.data.scanStatus) {
          clearInterval(checkWXTimer.value);
          loginForm.value.openId = res.data.openId;
          dialogVisible_login.value = false;
          loginType.value = "AUTHORIZATION";
          loginFunc();
        }
      } else {
        clearInterval(checkWXTimer.value);
        getWechatLoginQrCode()
      }
    });
};
const bindFunc = () => {
  if (loginLoading.value) return;
  loginLoading.value = true;
  auth.bind({
    "bindType": 1,
    "bindValue": loginForm.value.mobile,
    "verifyCode": loginForm.value.code,
    "platformId": 8,
    "platformCode": "YPLAN"
  }, {
    Authorization: `Bearer ` + bindToken.value,
    formplatformid: 8,
    tenantid: 2,
    formplatformcode: "YPLAN",
  }).then(res => {
    loginLoading.value = false;
    if (res.success) {
      dialogVisible_bind.value = false
      setUserLoginInfo(bindRes.value);
      localStorage.setItem("userToken", bindRes.value.access_token);
      localStorage.setItem("loginUser", JSON.stringify(bindRes.value));
    } else {
      ElMessage.info(res.data);
    }
  })
}
// 密码校验
const verifyUserBeforeLogin = () => {
  if (!loginForm.value.account || !loginForm.value.password) {
    return;
  }
  if (loginLoading.value) return;
  loginLoading.value = true;
  auth
    .verifyUserBeforeLogin({
      "account": loginForm.value.account,
      formPlatformId: 8, //重要，不同的应用这个值不一样
      tenantid: 2,
      formPlatformCode: "YPLAN", //重要，不同的应用这个值不一样
      "loginType": 0
    }).then(res => {
      loginLoading.value = false;
      if (res.success) {
        loginType.value = "ACCOUNT";
        loginForm.value.mobile = loginForm.value.account;
        loginFunc();
      }
    }).catch(err => {
      ElMessage.info('账户不存在，请使用微信或验证码注册登录')
    })
}
// 验证码校验
const verifyUserSmsCode = () => {
  if (!loginForm.value.mobile || !loginForm.value.code) {
    return;
  }
  if (loginLoading.value) return;
  loginLoading.value = true;
  auth
    .verifyUserSmsCode({
      mobile: loginForm.value.mobile,
      platformCode: "YPLAN",
      captcha: loginForm.value.code,
      platformId: 8,
    })
    .then((res) => {
      loginLoading.value = false;
      if (res.data == 0) {
        ElMessage.info("验证码错误");
      }
      if (res.data == 1) {
        clearInterval(checkWXTimer.value);
        auth.mobileRegister({
          mobile: loginForm.value.mobile,
          platformCode: "YPLAN",
          platformId: 8,
        }).then(resq => {
          if (resq.success) {
            setUserLoginInfo(resq);
            dialogVisible_login.value = false;
            dialogVisible_bind.value = false;
            localStorage.setItem("userToken", resq.access_token);
            localStorage.setItem("loginUser", JSON.stringify(resq));
          } else {
            ElMessage.info(resq.msg)
          }
        })
      }
      if (res.data == 2) {
        clearInterval(checkWXTimer.value)
        loginFunc();
      }
    });
};
// 最终的登录
const loginFunc = () => {
  clearInterval(checkWXTimer.value);
  let data = {};
  // 账密登录
  if (loginType.value == "ACCOUNT") {
    data.username = (loginForm.value.mobile + "").toLocaleLowerCase().trim();
    data.password = $config.encryptPwd(loginForm.value.password);
  }
  // 微信扫码登录
  if (loginType.value == "AUTHORIZATION") {
    data.username = loginForm.value.openId.toLocaleLowerCase().trim();
    data.password = $config.encryptPwd(data.username);
  }
  // 验证码登录
  if (loginType.value == "VCODE") {
    data.username = loginForm.value.mobile.toLocaleLowerCase().trim();
    data.password = $config.encryptPwd(data.username);
  }
  data.grant_type = "password";
  auth
    .login(data, {
      formplatformid: 8, //重要，不同的应用这个值不一样
      tenantid: 2,
      formplatformcode: "YPLAN", //重要，不同的应用这个值不一样
      logintype: loginType.value,
      certificate: "9999",
      "content-type": "application/x-www-form-urlencoded",
      Authorization: "Basic dGVzdDp0ZXN0",
    })
    .then((res) => {
      if (res.username) {
        bindRes.value = res;
        getUser(res)
      } else {
        ElMessage.info(res.msg)
      }
    });
};
const getUser = (loginData) => {
  auth
    .getUser({}, {
      Authorization: `Bearer ${loginData.access_token}`,
      formplatformid: 8,
      tenantid: 2,
      formplatformcode: "YPLAN",
    })
    .then((res) => {
      if (res.success && res.data.mobile) {
        setUserLoginInfo(loginData);
        dialogVisible_login.value = false;
        dialogVisible_bind.value = false;
        localStorage.setItem("userToken", loginData.access_token);
        localStorage.setItem("loginUser", JSON.stringify(loginData));
      } else {
        bindType.value = 'VCODE';
        bindToken.value = loginData.access_token;
        dialogVisible_bind.value = true;
      }
    });
}
// 发送验证码
const smsCode = () => {
  if (!loginForm.value.mobile || checkTime.value > 0) return;
  loginType.value = "VCODE";
  auth
    .smsCode({
      platformCode: "YPLAN",
      mobile: loginForm.value.mobile,
    })
    .then((res) => {
      if (res.success) {
        checkTime.value = 60;
        checkCodeTimer.value = setInterval(() => {
          checkTime.value -= 1;
          if (checkTime.value <= -1) clearInterval(checkCodeTimer.value);
        }, 1000);
      }
    });
};

</script>
<style lang="scss" scoped>
.headCont {
  width: 100%;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 14, 67, 0.06);
  position: sticky;
  z-index: 77;
  top: 0;
}

.headCont.dark {
  width: 100%;
  background: #2c2d3b;
  box-shadow: 0px 2px 4px 0px rgba(0, 14, 67, 0.06);
  position: sticky;
  top: 0;
  z-index: 88;
}

.logo {
  height: 24px;
  position: absolute;
  top: 21px;
  left: 20px;
  z-index: 1;
}

.loginBtn {
  width: 104px;
  height: 36px;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #b9c1ce;
  font-size: 14px;
  color: #393d4b;
  position: absolute;
  right: 20px;
  top: 15px;
}

.navigation {
  font-size: 14px;
  color: #393d4b;
  padding: 0 200px;
  width: 100%;
}

.themeSwitch {
  width: 46px;
  height: 20px;
  border-radius: 10px 10px 10px 10px;
  position: absolute;
  right: 150px;
  top: 23px;

  .themeSwitch_icon {
    position: absolute;
    top: 0;
    height: 20px;
  }
}

.themeSwitch.light {
  background: #ecf1fa;

  .themeSwitch_light {
    left: 0;
    opacity: 1;
  }

  .themeSwitch_dark {
    right: calc(100% - 20px);
    opacity: 0;
  }
}

.themeSwitch.dark {
  background: #57586f;

  .themeSwitch_dark {
    right: 0;
    opacity: 1;
  }

  .themeSwitch_light {
    left: calc(100% - 20px);
    opacity: 0;
  }
}

.dark {
  .navigation {
    span {
      color: #fff;
    }
  }

  .loginBtn {
    color: #fff;
  }
}
</style>
<style lang="scss">
.loginDialog {
  padding: 0 !important;

  .el-dialog__header {
    padding: 0;
  }

  .loginWx {

    height: 100%;
    width: 428px;

    .loginWxTitle {
      line-height: 20px;
      font-size: 14px;
      color: #333333;
      text-align: center;
      padding: 30px 0;
    }

    #qrCodeUrl {
      display: block;
      margin: 0 auto;
      width: max-content;
    }
  }

  .loginForm {
    height: 100%;
    flex: 1;
    padding: 0 60px;

    .loginFormTitle {
      padding: 30px 0;
      text-align: center;

      i {
        margin: 0 10px;
      }

      span {
        line-height: 20px;
        font-size: 14px;
        color: #333333;
      }

      .loginTypeOn {
        color: #4284ff;
      }
    }

    .el-input {
      width: 100%;
      line-height: 48px;
      height: 48px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #c2c9d6;
      overflow: hidden;
    }

    .el-select {
      line-height: 48px;
      height: 48px;
    }

    .el-select__wrapper {
      line-height: 48px;
      height: 48px;
      box-shadow: none !important;
      border: none !important;
      background-color: #fff !important;
      background: #fff !important;
    }

    .el-input__wrapper {
      box-shadow: none;
    }

    .el-input-group__append {
      box-shadow: none;
      background-color: #fff !important;
      background: #fff !important;
    }
  }

  .loginCont {
    width: 90vw;
    max-width: 886px;
    height: 516px;

    .loginTitle {
      line-height: 28px;
      font-weight: 600;
      font-size: 20px;
      color: #333333;
      text-align: center;
      padding: 60px 0 30px 0;
    }
  }

  .smsCode.pointer {
    color: #5e8cff;
  }

  .smsCode.no-drop {
    color: #a9aeb4;
  }

  .loginSubmit {
    width: 100%;
    height: 48px;
    border-radius: 10px 10px 10px 10px;
    font-size: 16px;
    color: #ffffff;
    margin-top: 30px;
  }

  .loginSubmit.pointer {
    background: #5e8cff;
  }

  .loginSubmit.no-drop {
    background: #a4c4ff;
  }

  .loginCheck {
    color: #333333;
    margin-top: 14px;
    font-size: 14px;

    .loginCheckbox {
      width: 18px;
      margin-right: 4px;
    }

    span {
      color: #488eff;
    }
  }
}
</style>
